import React from "react";

import MuiMenuItem, {
  MenuItemProps as MuiMenuItemProps,
} from "@mui/material/MenuItem";
import styled from "@mui/material/styles/styled";

export interface MenuItemProps extends MuiMenuItemProps {
  icon?: React.ReactNode;
  type?: "default" | "error";
}

const MenuItem = styled(
  ({ icon, children, type: _, ...props }: MenuItemProps) => {
    return (
      <MuiMenuItem {...props}>
        {icon}
        {children}
      </MuiMenuItem>
    );
  }
)(({ theme, type = "default" }) => ({
  color: theme.palette.shades.neutral[700],
  fontSize: "0.875rem",
  lineHeight: "18px",
  borderRadius: "4px",
  padding: "8px",
  minHeight: 0,
  "&:hover": {
    backgroundColor:
      type === "error"
        ? theme.palette.shades.negative[50]
        : theme.palette.shades.ghost[500],
    "& > .MuiSvgIcon-root": {
      color: type === "error" ? theme.palette.error.main : undefined,
    },
  },

  "&.Mui-disabled": {
    backgroundColor: "#EEE",
  },
  "& > .MuiSvgIcon-root": {
    color: theme.palette.shades.neutral[300],
    width: "16px",
    height: "16px",
    marginRight: "8px",
  },
}));

export default MenuItem;
